import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DeferredToastService } from 'src/app/services/deferred-toast.service';
import { AssetStatus } from 'src/app/models/building.model';
import { Customer, CustomerEdit } from 'src/app/models/customer.model';
import { F11Crud } from 'src/app/models/feeder11.model';
import { F33Crud } from 'src/app/models/feeder33.model';
import { EntityType, ImageType } from 'src/app/models/image.model';
import { User } from 'src/app/models/user.model';
import { BuildingService } from 'src/app/services/building.service';
import { CustomerService } from 'src/app/services/customer.service';
import { DtService } from 'src/app/services/dt.service';
import { F11Service } from 'src/app/services/f11.service';
import { F33Service } from 'src/app/services/f33.service';
import { MeterService } from 'src/app/services/meter.service';
import { UserService } from 'src/app/services/user.service';
import { HistoryOutput } from 'src/app/models/history.model';
import { PermissionsEnum } from 'src/app/models/role.model';
import { TranslationService } from 'src/app/services/translation.service';
import { AcLineSegmentService, AuthService, CimSubstationService, PermissionsService } from 'shared-lib';
import { RecallType } from 'src/app/models/recallType.model';
import { AssetStatusEnum } from 'src/app/models/assetStatus.model';
import { MeterType } from '../../../models/meter.model';
import { OptionObj } from 'src/app/models/util.model';
import { BlobStorageService } from 'src/app/_modules/shared/_services/blob-storage.service';
import { ContainerNames } from 'src/app/models/containerNames.model';

@Component({
  selector: 'edit-meter',
  templateUrl: './edit-meter.component.html',
  styleUrls: ['./edit-meter.component.scss'],
})
export class EditMeterComponent implements OnInit {
  PermissionsEnum = PermissionsEnum;

  AssetAssignType = AssetStatusEnum;
  assetAssignType: AssetStatusEnum;

  customer: CustomerEdit = new CustomerEdit();
  longitude: number = 0;
  latitude: number = 0;
  customerHeaderInfo: Customer = new Customer();
  mobileUsers: User[] = [];
  assignedUserId: number = 0;

  ImageType = ImageType;
  EntityType = EntityType;
  billImage: File | null;
  buildingImage: File | null;
  selectedImage: any;
  isImageMapVisible: boolean = false;

  editEnabled: boolean = false;
  meterEditEnabled: boolean = false;
  f11Options: F11Crud[] = [];
  f33Options: F33Crud[] = [];
  dtOptions: OptionObj[] = [];
  acLines: any[] = [];
  substations: any[] = [];
  selectableSubstations: any[] = [];
  selectedAcLineId: number = 0;
  sltStatus: string = '';
  sltOptions: OptionObj[] = [];
  meterTypeOptions: OptionObj[] = [];
  openApproveModal: boolean = false;
  openRejectModal: boolean = false;
  rejectionReason = '';
  customerId = 0;
  customerType = '';
  @ViewChild('closeModal') closeModal: ElementRef;
  @ViewChild('closeDQModal') closeDQModal: ElementRef;
  @ViewChild('openUpdateDescriptionModal')
  openUpdateDescriptionModal: ElementRef;
  @ViewChild('dropdownContainer') dropdownContainer: ElementRef;
  @ViewChild('userFilterInput') userFilter: ElementRef;

  filterText: string = '';
  isDropdownOpened: boolean = false;
  filteredMobileUsers: User[] = [];
  tempAssignedUserId: number = 0;
  buName: string = this.translationService.getByKeyFromStorage('BU');
  contractNumber: string =
    this.translationService.getByKeyFromStorage('Contract number');
  utName: string = this.translationService.getByKeyFromStorage('UT');
  dtName: string = this.translationService.getByKeyFromStorage('DTNumber');

  history: HistoryOutput = new HistoryOutput();
  isMapVisible: boolean = false;
  showRecallMenu: boolean = false;
  recallAssignedAllowed: boolean = false;
  recallValidatedAllowed: boolean = false;
  isServiceTypeFieldVisible: boolean = true;
  isMeterSlrnFieldVisible: boolean = true;
  isFrmMeterVisible: boolean = true;
  isInstallationDateVisible: boolean = true;
  isReplacementDateVisible: boolean = true;
  isNewMeterPictureVisible: boolean = true;
  isImageMeterFieldVisible: boolean = true;
  isBackViewPictureFieldVisible: boolean = true;
  hasCimDataIntegration: boolean = false;
  sltStatusName: string =
    this.translationService.getByKeyFromStorage('SltStatus');
  selectedSltStatus: OptionObj = {
    key: 0,
    value: '',
  };

  timeZone: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private customerService: CustomerService,
    private toastr: ToastrService,
    private deferredToastService: DeferredToastService,
    private meterService: MeterService,
    private buildingService: BuildingService,
    private userService: UserService,
    private f11Service: F11Service,
    public permissionsService: PermissionsService,
    private f33Service: F33Service,
    private dtService: DtService,
    private router: Router,
    private translationService: TranslationService,
    private blobStorageService: BlobStorageService,
    private authService: AuthService,
    private cimSubstationService: CimSubstationService,
    private acLineSegmentService: AcLineSegmentService
  ) {
    this.hasCimDataIntegration = this.authService.hasCimDataIntegration;
  }

  ngOnInit(): void {
    this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.blobStorageService.setContainer(ContainerNames.Images);
    const customerId = this.activatedRoute.snapshot.paramMap.get('customerId');
    this.setFieldsVisibility();
    this.customerId = Number(customerId);
    this.getCustomer(customerId);
    if(!this.hasCimDataIntegration) {
      this.getFeedersForOptions();
    }
    this.getSltStatusesForOptions();
    this.getMeterTypesForOptions();
    this.deferredToastService.showQueuedMessage();
  }

  setModalType(type: AssetStatusEnum) {
    this.assetAssignType = type;
  }

  getMeterTypesForOptions() {
    this.meterService.getMeterTypesForOptions().subscribe(
      (response) => {
        this.meterTypeOptions = response.body.data;
      },
      (error) => {
        this.toastr.error('An error occurred.');
      }
    );
  }

  getSltStatusesForOptions() {
    this.customerService.getSltStatusesForOptions().subscribe(
      (response) => {
        this.sltOptions = response.body.data;
      },
      (error) => {
        this.toastr.error('An error occurred.');
      }
    );
  }

  getFeedersForOptions() {
    this.f11Service.getAllForSelect().subscribe(
      (response) => {
        this.f11Options = response.body.data;
      },
      (error) => {
        this.toastr.error('An error occurred.');
      }
    );

    this.f33Service.getAllForSelect().subscribe(
      (response) => {
        this.f33Options = response.body.data;
      },
      (error) => {
        this.toastr.error('An error occurred.');
      }
    );
  }

  getDtsForOptions(feederId: number) {
    this.dtService
      .getAllForSelectByFeeder(
        feederId,
        this.customer.dt?.feeder?.feederType.toString()
      )
      .subscribe(
        (response) => {
          this.dtOptions = response.body.data;
        },
        (error) => {
          this.toastr.error('An error occurred.');
        }
      );
  }

  private getCustomer(customerId: any) {
    this.customerService.getCustomerForMeter(customerId).subscribe({
      next: (response) => {
      
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
        
          this.customer = new CustomerEdit(responseData.data);
          this.longitude = this.customer.building.longitude;
          this.latitude = this.customer.building.latitude;
          this.customerType =
            this.customer.customerType != null
              ? this.customer.customerType.toString()
              : '';
          this.assignedUserId =
            this.customer.building.assignedUserId !== 0
              ? this.customer.building.assignedUserId
              : 0;
          this.customer.feederId = this.customer.dt?.feeder?.id;
          this.customer.dtId = this.customer.dt ? this.customer.dt.id : 0;
          this.customer.substationId = this.customer.substationId ?? null;
          this.customer.meterTypeId = this.customer.meter?.meterType
            ? this.customer.meter?.meterType?.id
            : 0;
          this.customer.meterNo = this.customer.meter
            ? this.customer.meter.number
            : '';
          this.filterText = this.customer.building.assignedUser
            ? this.customer.building.assignedUser
            : '';
          this.selectedSltStatus.key = this.customer.sltStatus?.id;
          this.selectedSltStatus.value = this.customer.sltStatus?.value;
          this.tempAssignedUserId = this.assignedUserId;
          if (this.customer.feederId) {
            this.getDtsForOptions(this.customer.feederId);
          }
          if (this.hasCimDataIntegration) {
            this.prefillCim();
          }
          this.formatHeaderInfo(this.customer);

          if (
            this.permissionsService.isCustomerRecallAssignedAllowed &&
            !(
              this.customer.dataQualityStatus?.toString() != 'Rejected' &&
              this.customer.building.status != 'Assigned'
            )
          ) {
            this.recallAssignedAllowed = true;
          }

          if (
            this.permissionsService.isCustomerRecallValidatedAllowed &&
            this.customer.dataQualityId != 0
          ) {
            this.recallValidatedAllowed = true;
          }
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  getMobileUsers() {
    this.userService
      .getMobileUsers(this.customer.area.id, this.filterText)
      .subscribe({
        next: (response) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.mobileUsers = responseData.data;
            if (this.mobileUsers.length == 0) {
              this.isDropdownOpened = false;
            }
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: (_) => {
          this.toastr.error('Error occured');
        },
      });
  }
  openDropdown() {
    this.isDropdownOpened = true;
  }

  getBuildingImageByType(imageType: string, index?: number) {
    return this.customer.buildingImages.filter((x) => x.imageType === imageType)[index ?? 0];
  }

  getCustomerImageByType(imageType: string) {
    return this.customer.customerImages.find((x) => x.imageType === imageType);
  }

  getBuildingMountedImage() {
    return this.customer.buildingImages.find(
      (x) => x.imageType === 'MountedTag'
    )?.url;
  }

  getFrontViewImage(id: number) {
    return this.customer.buildingImages.filter(
      (x) => x.imageType === 'Frontview'
    )[id]?.url;
  }

  edit() {
    this.editEnabled = true;
    this.meterEditEnabled = this.editEnabled && !!this.customer.meter.number;
  }

  save() {
    if (this.customer.meter.meterType == null) {
      this.customer.meter.meterType = new MeterType();
      this.customer.meter.meterType.id = this.customer.meterTypeId;
    } else {
      this.customer.meter.meterType.id = this.customer.meterTypeId;
    }
    if (
      this.customer.sltStatus?.id !== this.selectedSltStatus.key &&
      this.selectedSltStatus.key !== 0
    ) {
      this.customer.sltStatus.id = this.selectedSltStatus.key;
      this.customer.sltStatus.value = this.selectedSltStatus.value;
    }
    this.meterService.saveMeterDetails(this.customer).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.openUpdateDescriptionModal?.nativeElement?.click();
          this.editEnabled = false;
          this.formatHeaderInfo(this.customer);
          this.deferredToastService.queueSuccess('Successfully updated record. Status reverted to Pending.');
          window.location.reload();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  formatHeaderInfo(customer: CustomerEdit) {
    this.customerHeaderInfo.tenantName = customer.tenantName;
    this.customerHeaderInfo.slrn = customer.building.slrn;
    this.customerHeaderInfo.email = customer.email;
    this.customerHeaderInfo.phoneNumber = customer.phoneNumber;
    this.customerHeaderInfo.address = customer.address;
  }

  assignTask(): void {
    if (
      this.mobileUsers.filter(
        (x) => x.firstName + ' ' + x.lastName == this.filterText
      ).length > 0
    ) {
      this.assignedUserId = this.mobileUsers.filter(
        (x) => x.firstName + ' ' + x.lastName == this.filterText
      )[0].id;
      this.tempAssignedUserId = this.assignedUserId;
    } else {
      this.tempAssignedUserId = 0;
    }
    if (this.tempAssignedUserId != 0) {
      this.meterService
        .assignMeter(
          this.customer.meter.id,
          this.assignedUserId,
          this.assetAssignType
        )
        .subscribe({
          next: (response) => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === 'OK') {
              this.closeModal?.nativeElement?.click();
              this.toastr.success('Successfully assigned user');
            } else {
              this.toastr.error(responseData?.message);
            }
          },
          error: (_) => {
            this.toastr.error('Error occured');
          },
        });
    } else {
      this.toastr.warning('Please select valid user.');
    }
  }

  showImage(type: ImageType, num?: number) {
    switch (type) {
      case ImageType.Frontview:
        this.selectedImage = this.getBuildingImageByType('Frontview', num!);
        break;
      case ImageType.MountedTag:
        this.selectedImage = this.getBuildingImageByType('MountedTag');
        break;
      case ImageType.Bill:
        this.selectedImage = this.getCustomerImageByType('Bill');
        break;
      case ImageType.Card:
        this.selectedImage = this.getCustomerImageByType('Card');
        break;
      case ImageType.Meter:
        this.selectedImage = this.getCustomerImageByType('Meter');
        break;
      case ImageType.MeterNumber:
        this.selectedImage = this.getCustomerImageByType('MeterNumber');
        break;
      case ImageType.CardBackViewImage:
        this.selectedImage = this.getCustomerImageByType('CardBackViewImage');
        break;
      case ImageType.MeterReplacementReadingImage:
        this.selectedImage = this.getCustomerImageByType('MeterReplacementReadingImage');
        break;
    }
  }

  selectFeeder() {
    this.customer.dtId = 0;
    this.getDtsForOptions(this.customer.feederId);
  }

  cancelModal(event: any) {
    this.closeDQModal?.nativeElement?.click();
    if (event.isBuilding) {
      this.router.navigateByUrl(`/buildings/edit/${event.id}`);
    } else {
      if (event.isOnBoard) {
        this.router.navigateByUrl(`/customers/edit/${event.id}`);
      } else {
        this.router.navigateByUrl(`/customers/edit/${event.id}`);
      }
    }
  }

  updateStatus(event: any, type: string) {
    var status = AssetStatus.Pending;
    if (type === 'approve') status = AssetStatus.Complete;
    else status = AssetStatus.Incomplete;

    const obj = {
      customerId: this.customer.id,
      status: status,
      rejectionReason: this.rejectionReason,
    };
    this.customerService.updateStatus(obj).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.deferredToastService.queueSuccess('Successfully');
          window.location.reload();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  updateHistory(history: any) {
    this.history = history;
    this.customer.history = this.history;
    this.save();
  }

  openEditModal() {
    this.openUpdateDescriptionModal?.nativeElement?.click();
  }

  filterMobileUsers() {
    this.isDropdownOpened = true;
    this.tempAssignedUserId = 0;
    this.getMobileUsers();
  }

  selectFieldAgent(id: number) {
    this.isDropdownOpened = false;
    this.assignedUserId = id;
    this.tempAssignedUserId = id;
    var mobUser = this.mobileUsers.find((x) => x.id == id);
    if (mobUser?.firstName && mobUser?.lastName) {
      this.filterText = mobUser!.firstName + ' ' + mobUser?.lastName;
    } else {
      this.filterText = mobUser!.firstName;
    }
  }
  recallAssigned() {
    this.buildingService
      .recall(this.customer.building.id, RecallType.Assigned)
      .subscribe({
        next: (response) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.deferredToastService.queueSuccess('Successfully recalled customer.');
            window.location.reload();
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: (_) => {
          this.toastr.error('Error occured');
        },
      });
  }

  recallValidation() {
    this.customerService.recallDataQuality(this.customer.id).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.deferredToastService.queueSuccess("Successfully recalled customer's Data Quality.");
          window.location.reload();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  @HostListener('document:click', ['$event'])
  handleDocumentClick(event: MouseEvent) {
    const clickedInside =
      this.isDropdownOpened &&
      (this.dropdownContainer?.nativeElement?.contains(event.target) ||
        this.userFilter?.nativeElement?.contains(event.target));
    if (!clickedInside) {
      this.isDropdownOpened = false;
    }
  }

  setFieldsVisibility() {
    let notVisibleFields: any = localStorage.getItem('notVisibleFields');

    if (!notVisibleFields) {
      return;
    }

    notVisibleFields = JSON.parse(notVisibleFields);
    this.isMeterSlrnFieldVisible = notVisibleFields.find(
      (el: any) => el === 'meterSlrn'
    )
      ? false
      : true;
    this.isServiceTypeFieldVisible = notVisibleFields.find(
      (el: any) => el === 'serviceType'
    )
      ? false
      : true;

    this.isFrmMeterVisible = notVisibleFields.find(
      (el: any) => el === 'frmMeterNumber'
    )
      ? false
      : true;

    this.isInstallationDateVisible = notVisibleFields.find(
      (el: any) => el === 'installationDate'
    )
      ? false
      : true;

    this.isReplacementDateVisible = notVisibleFields.find(
      (el: any) => el === 'replacementDate'
    )
      ? false
      : true;

    this.isNewMeterPictureVisible = notVisibleFields.find(
      (el: any) => el === 'newMeterPicture'
    )
      ? false
      : true;

    this.isImageMeterFieldVisible = notVisibleFields.find(
      (el: any) => el === 'imageMeter'
    )
      ? false
      : true;
    this.isBackViewPictureFieldVisible = notVisibleFields.find(
      (el: any) => el === 'backViewPicture'
    )
      ? false
      : true;
  }

  fileBrowserHandler({ file, type, imageId }: { file: File, type: ImageType, imageId: number }) {
    if (!file) {
      this.toastr.error('Image data is missing');
      return;
    }
  
    if (this.isCustomerImageType(type)) {
      this.handleCustomerImageUpload(file, type, imageId);
    } else {
      this.handleBuildingImageUpload(file, type, imageId);
    }
  }

  private isCustomerImageType(type: ImageType): boolean {
    return (
      type === ImageType.Bill ||
      type === ImageType.Card ||
      type === ImageType.Meter ||
      type === ImageType.MeterNumber ||
      type === ImageType.CardBackViewImage
    );
  }

  private handleCustomerImageUpload(
    file: File,
    type: ImageType,
    imageId: number
  ) {
    this.blobStorageService.uploadFile(
      file,
      file.name,
      (uploadedUrl) => {
        const obj = {
          imageType: type,
          customerId: this.customer.id,
          guid: this.customer.guid,
          url: uploadedUrl,
          imageId: imageId,
        };

        this.customerService
          .uploadPicture(obj, file, this.customer.guid)
          .subscribe({
            next: (response) =>
              this.handleCustomerUploadResponse(response, type),
            error: (_) =>
              this.toastr.error('Error occurred while uploading to the server'),
          });
      },
      (error) => {
        console.error('Error uploading image to blob storage:', error);
        this.toastr.error('Failed to upload image to storage');
      }
    );
  }

  private handleBuildingImageUpload(
    file: File,
    type: ImageType,
    imageId: number
  ) {
    this.blobStorageService.uploadFile(
      file,
      file.name,
      (uploadedUrl) => {
  

        const obj = {
          imageType: type,
          buildingId: this.customer.building.id,
          guid: this.customer.building.guid,
          url: uploadedUrl,
          imageId: imageId,
        };

        this.buildingService.uploadPicture(obj, file).subscribe({
          next: (response) => this.handleBuildingUploadResponse(response, type, imageId),
          error: (_) =>
            this.toastr.error('Error occurred while uploading to the server'),
        });
      },
      (error) => {
        console.error('Error uploading building image to blob storage:', error);
        this.toastr.error('Failed to upload building image to storage');
      }
    );
  }

  private handleCustomerUploadResponse(response: any, type: ImageType) {
    const responseData = response.body;
    if (responseData?.status === 200 || responseData?.status === 'OK') {
      switch (type) {
        case ImageType.Bill:
          this.customer.billImageUrl = responseData.data.url;
          break;
        case ImageType.Card:
          this.customer.cardImageUrl = responseData.data.url;
          break;
        case ImageType.Meter:
          this.customer.meterImageUrl = responseData.data.url;
          break;
        case ImageType.MeterNumber:
          this.customer.meterNumberImageUrl = responseData.data.url;
          break;
        case ImageType.CardBackViewImage:
          this.customer.backCardViewImageUrl = responseData.data.url;
          break;
      }
      this.toastr.success('Successfully added image');
    } else {
      this.toastr.error(responseData?.message);
    }
  }

  disableUpdateStatusButton() {
    if (this.customer.dataQualityId === 0) return false;
    else return true;
  }

  private handleBuildingUploadResponse(response: any, type: ImageType, imageId: number) {
    const responseData = response.body;
    if (responseData?.status === 200 || responseData?.status === 'OK') {
      if (imageId != -1) {
        const images = this.customer.buildingImages.filter(x => x.imageType == ImageType[type]);
        const imageIndex = this.customer.buildingImages.indexOf(images[imageId]);
        this.customer.buildingImages[imageIndex] = responseData.data;
      } else this.customer.buildingImages.push(responseData.data);
    this.toastr.success('Successfully added image');
  } else {
    this.toastr.error(responseData?.message);
  }
  }

  private prefillCim() {
    this.selectedAcLineId = this.customer.acLineId ?? 0;
    this.getAcLines();
    this.getSubstations();
  }

  getAcLines() {
    this.acLineSegmentService
      .getAllACLinesCached({ voltageClasses: ["MV","HV"] })
      .subscribe({
        next: (response: any) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.acLines = responseData.data ?? [];
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: () => this.toastr.error('Error occured'),
      });
  }

  getSubstations() {
    this.cimSubstationService
      .getAllSubstationsCached({ voltageClasses: [1] })
      .subscribe({
        next: (response: any) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.substations = responseData.data ?? [];
            this.refreshSelectableSubstations();
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: () => this.toastr.error('Error occured'),
      });
  }

  selectAcLine(e: any) {
    this.selectedAcLineId = +e.target.value;
    const line = this.acLines.find((x) => x.id === this.selectedAcLineId);
    this.customer.substation.feederName = line?.name;
    this.customer.substation.feederNumber = line?.number ?? '';
    this.customer.substationId = null;
    this.refreshSelectableSubstations();
  }

  selectSubstation(e: any) {
    this.customer.substationId = +e.target.value;
    this.customer.substation.id = +e.target.value;
    const line = this.substations.find((x) => x.id === this.customer.substationId);
    this.customer.substation.dtName = line?.name;
    this.customer.substation.dtNumber = line?.number ?? '';
  }

  private refreshSelectableSubstations() {
    if (this.selectedAcLineId) {
      this.selectableSubstations = this.substations.filter((s) =>
        (s.incomingACLines ?? []).some((l: any) => l.id === this.selectedAcLineId)
      );
    } else {
      this.selectableSubstations = this.substations;
    }
  }
}
